import React, { useState, useEffect } from 'react';
import '../MotorradForms.css';
import { sendFrontAction } from '../services/api'; 

const MotorradServiceRequest = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '+998 ', 
        bikeModel: 'BMW S 1000 XR', 
        serviceType: 'ТО(Техническое Обслуживание)', 
        comment: '',
        driverName: '',
        driverPhone: '+998 '
    });

    const [hasDriver, setHasDriver] = useState(false);
    const [message, setMessage] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});

    // Стейт для управления красивым модальным окном
    const [modal, setModal] = useState({
        isOpen: false,
        type: 'success', // success или error
        title: '',
        text: ''
    });

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const validateForm = () => {
        const errors = {};
        const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s]{2,50}$/;
        const phoneRegex = /^\+998\d{9}$/;

        if (!formData.name.trim()) {
            errors.name = 'Имя обязательно для заполнения';
        } else if (!nameRegex.test(formData.name.trim())) {
            errors.name = 'Имя должно содержать только буквы и быть не короче 2 символов';
        }

        const cleanPhone = formData.phone.replace(/\s+/g, '');
        if (cleanPhone === '+998') {
            errors.phone = 'Номер телефона обязателен';
        } else if (!phoneRegex.test(cleanPhone)) {
            errors.phone = 'Введите корректный номер телефона: +998 (XX) XXX-XX-XX';
        }

        if (hasDriver) {
            if (!formData.driverName.trim()) {
                errors.driverName = 'Укажите имя водителя/друга';
            } else if (!nameRegex.test(formData.driverName.trim())) {
                errors.driverName = 'Имя водителя должно содержать только буквы';
            }

            const cleanDriverPhone = formData.driverPhone.replace(/\s+/g, '');
            if (cleanDriverPhone === '+998') {
                errors.driverPhone = 'Укажите телефон водителя/друга';
            } else if (!phoneRegex.test(cleanDriverPhone)) {
                errors.driverPhone = 'Неверный формат телефона водителя';
            }
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        let value = e.target.value;
        if ((e.target.name === 'phone' || e.target.name === 'driverPhone') && !value.startsWith('+998 ')) {
            value = '+998 ';
        }
        setFormData({ ...formData, [e.target.name]: value });
        if (fieldErrors[e.target.name]) {
            setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        if (!validateForm()) {
            setMessage('❌ Пожалуйста, исправьте ошибки в форме');
            return;
        }

        setMessage('Отправка заявки на сервис...');

        const dataToSend = {
            ...formData,
            phone: formData.phone.replace(/\s+/g, ''),
            driverName: hasDriver ? formData.driverName : '',
            driverPhone: hasDriver ? formData.driverPhone.replace(/\s+/g, '') : ''
        };

        try {
            const result = await sendFrontAction('motorrad_service', dataToSend);
            
            if (result.success) {
                setMessage('');
                // Показываем красивое окно успеха
                setModal({
                    isOpen: true,
                    type: 'success',
                    title: 'Заявка принята!',
                    text: result.message || 'Мы свяжемся с вами в ближайшее время для подтверждения записи на сервис.'
                });

                setFormData({
                    name: '',
                    phone: '+998 ',
                    bikeModel: 'BMW S 1000 XR',
                    serviceType: 'ТО(Техническое Обслуживание)',
                    comment: '',
                    driverName: '',
                    driverPhone: '+998 '
                });
                setHasDriver(false);
                setFieldErrors({});
            }
        } catch (error) {
            setMessage('');
            if (error.errors) {
                setFieldErrors(error.errors);
                setMessage('❌ Ошибка валидации на сервере');
            } else {
                // Показываем всплывающее окно в случае системной ошибки
                setModal({
                    isOpen: true,
                    type: 'error',
                    title: 'Ошибка отправки',
                    text: error.message || 'Не удалось отправить заявку. Пожалуйста, попробуйте позже.'
                });
            }
        }
    };

    return (
        <div className="form-page-wrapper">
            <div className="form-container-box">
                <div className="form-header-zone">
                    <h1>ЗАПИСЬ <span className="highlight-text">НА СЕРВИС</span></h1>
                    <p>Доверьте обслуживание вашего мотоцикла официальному сервису BMW Motorrad</p>
                </div>

                {message && (
                    <div className="form-status-message error">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="premium-form" noValidate>
                    <div className="form-group-row">
                        <div className="input-field">
                            <label>Ваше имя *</label>
                            <input 
                                type="text" 
                                name="name" 
                                placeholder="Введите имя" 
                                value={formData.name} 
                                onChange={handleChange} 
                                className={fieldErrors.name ? 'input-error' : ''} 
                            />
                            {fieldErrors.name && <span className="error-text">{fieldErrors.name}</span>}
                        </div>
                        
                        <div className="input-field">
                            <label>Номер телефона *</label>
                            <input 
                                type="text" 
                                name="phone" 
                                placeholder="+998 90 123 45 67" 
                                value={formData.phone} 
                                onChange={handleChange}
                                className={fieldErrors.phone ? 'input-error' : ''} 
                            />
                            {fieldErrors.phone && <span className="error-text">{fieldErrors.phone}</span>}
                        </div>
                    </div>

                    <div className="checkbox-field"> 
                        <input 
                            type="checkbox" 
                            id="hasDriver" 
                            checked={hasDriver} 
                            onChange={(e) => {
                                setHasDriver(e.target.checked);
                                if(!e.target.checked) setFieldErrors(prev => ({...prev, driverName: '', driverPhone: ''}));
                            }}
                        />
                        <label htmlFor="hasDriver">
                            Мотоцикл привезет водитель эвакуатора или друг
                        </label>
                    </div>

                    {hasDriver && (
                        <div className="form-group-row driver-fields-container"> 
                            <div className="input-field">
                                <label>Имя водителя / друга *</label>
                                <input 
                                    type="text" 
                                    name="driverName" 
                                    placeholder="Имя того, кто доставит байк" 
                                    value={formData.driverName} 
                                    onChange={handleChange} 
                                    className={fieldErrors.driverName ? 'input-error' : ''}
                                />
                                {fieldErrors.driverName && <span className="error-text">{fieldErrors.driverName}</span>}
                            </div>
                            <div className="input-field">
                                <label>Телефон водителя / друга *</label>
                                <input 
                                    type="text" 
                                    name="driverPhone" 
                                    placeholder="+998 90 000 00 00" 
                                    value={formData.driverPhone} 
                                    onChange={handleChange} 
                                    className={fieldErrors.driverPhone ? 'input-error' : ''}
                                />
                                {fieldErrors.driverPhone && <span className="error-text">{fieldErrors.driverPhone}</span>}
                            </div>
                        </div>
                    )}

                    <div className="form-group-row">
                        <div className="input-field">
                            <label>Модель мотоцикла</label>
                            <select name="bikeModel" value={formData.bikeModel} onChange={handleChange}>
                                <option value="BMW S 1000 XR">BMW S 1000 XR</option>
                                <option value="BMW S 1000 RR">BMW S 1000 RR</option>
                                <option value="BMW M 1000 XR">BMW M 1000 XR</option>
                                <option value="BMW M 1000 R">BMW M 1000 R</option>
                                <option value="BMW M 1000 RR">BMW M 1000 RR</option>
                                <option value="BMW R 1300 RT">BMW R 1300 RT</option>
                                <option value="BMW S 1000 R">BMW S 1000 R</option>
                                <option value="BMW F 900 R">BMW F 900 R</option>
                                <option value="BMW R 1300 GS">BMW R 1300 GS</option>
                                <option value="BMW R 1300 GS Adventure">BMW R 1300 GS Adventure</option>
                                <option value="BMW F 450 GS">BMW F 450 GS</option>
                            </select>
                        </div>
                        <div className="input-field">
                            <label>Тип услуги</label>
                            <select name="serviceType" value={formData.serviceType} onChange={handleChange}>
                                <option value="ТО(Техническое Обслуживание)">ТО(Техническое Обслуживание)</option>
                                <option value="Другое">Другое</option>
                            </select>
                        </div>
                    </div>

                    <div className="input-field">
                        <label>Комментарий</label>
                        <textarea name="comment" rows="4" placeholder="Опишите проблему или укажите желаемую дату визита" value={formData.comment} onChange={handleChange}></textarea>
                    </div>

                    <button type="submit" className="form-submit-btn">ОТПРАВИТЬ ЗАЯВКУ</button>
                </form>
            </div>

            {/* ВСПЛЫВАЮЩЕЕ ОКНО (MODAL) */}
            {modal.isOpen && (
                <div className="modal-overlay">
                    <div className="modal-card">
                        <div className={`modal-icon-wrap ${modal.type === 'error' ? 'error-theme' : ''}`}>
                            {modal.type === 'success' ? '✓' : '✕'}
                        </div>
                        <h2>{modal.title}</h2>
                        <p>{modal.text}</p>
                        <button className="modal-close-btn" onClick={() => setModal({ ...modal, isOpen: false })}>
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MotorradServiceRequest;